import log from 'loglevel'
import Vue from 'vue'
import SystemChecker from './SystemChecker'

log.setLevel('debug', true)

if (!window.SYSTEM_CHECK) {
  window.SYSTEM_CHECK = {
    exportUrl: 'http://demo.6connexlocal.com/event/system-check/export',
    imageDownloadUrl: 'http://demo.6connexlocal.com/event/local-files/assets/images/speed-test.jpg',
    cdnCheckUrl: 'http://demo.6connexlocal.com/event/local-files/assets/system-check/img/1x1.png',
    realTimeServers: [
      {name: 'rts1', url: 'https://demo.6connexlocal.com:8000'}
    ],
    videos: {
      poster: 'http://cdn-akamai.6connex.com/files/6connex/v7-intro.png',
      mp4: 'http://v7qa.6connex.com/upload/files/6connex/v7-intro.mp4',
      webm: 'http://v7qa.6connex.com/upload/files/6connex/v7-intro.webm'
    },
    i18n: {
      title: 'System Checker',
      description: 'This system check covers standard platform functionality. It does not cover requirements for any 3rd party services that may be integrated into the experience.',
      complete: 'Completed!',
      checking: 'Checking...',
      downloadCSV: 'Download CSV',
      connectionSpeed: 'Connection Speed',
      popUpBlocker: 'Popup Blocker Disabled',
      screenResolution: 'Screen Resolution',
      browserSize: 'Browser Size',
      cdn: 'CDN Access',
      cookieEnabled: 'Cookie Enabled',
      browser: 'Web Browser',
      operatingSystem: 'Operation System',
      rts: 'Real Time Server Access',
      videoPlayer: 'Video Player',
      videoPlayerInit: 'Initializing video player...',
      apiAccess: 'AWS API access',
      results: {
        popUpBlocker: 'Please disable your popup blocker. If you do not, some content may not display correctly for you.',
        screenResolution: 'Your screen resolution is below the recommended minimum of 1024 x 768. If you do not raise your resolution, the UI may not fit completely into your browser window.',
        browserSize: 'Your browser\'s current viewable area is less than 1000 pixels wide by 640 pixels high. While you may be able to see some of the Virtual Experience, you will not be able to see all essential elements. Please enlarge your browser window.',
        cdn: 'It seems that you cannot connect to our CDN server to download the test file.',
        cookieEnabled: 'Please use your browser settings to enable cookies. If you do not, certain features may not function properly.',
        connectionSpeedBelowMinimum: 'Your connection speed is below the minimum 384Kbps to take advantage of a rich media experience. Minimum speed for a smooth experience is 800Kbps.',
        connectionSpeedBelowMedium: 'Your connection speed is below the recommended 800Kbps for an optimum experience. While you can still participate in this virtual environment, some video and audio may not play smoothly for you.'
      }
    }
  }
}

log.info('System Check settings are ', window.SYSTEM_CHECK)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<SystemChecker/>',
  components: { SystemChecker }
})



// WEBPACK FOOTER //
// ./src/main.js